import React from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2';
import { getFieldQuestion } from '../util';
const CreateFieldsAssetInventory = ({
	assetInventories,
	activeAssetInventory,
	timezone,
	showFormFile,
	getTextFileHeader
}) => {
	const lan = useLanguage();
	const Fields = () => {
		let fields = assetInventories[activeAssetInventory].questions;
		if (fields != null && fields.length > 0) {
			return fields.map((field, i) => (
				<div key={'Forms-row-' + i} className='mt-4'>
					{getFieldQuestion(field, showFormFile, timezone, lan, getTextFileHeader,false)}
				</div>
			));
		} else  {
			return <div className='mt-4'>{lan.noQuestions}</div>;
		}
	};
	return (
		<div>
			<Grid container className='mt-4'>
				<Grid size={10} className='ml-auto mr-5'>
          <b>{lan.questions}</b>
				</Grid>
			</Grid>
			<Fields />
		</div>
	);
};

export default CreateFieldsAssetInventory;
